import {
  LOAD_JOB,
  CREATE_JOB,
  UPDATE_JOB,
  TERMINATE_JOB
} from "../actions/job";
import _ from "lodash";

export default function(state = [], action) {
  switch (action.type) {
    case LOAD_JOB:
      return action.payload;
    case CREATE_JOB:
      state.push(action.payload);
      return JSON.parse(JSON.stringify(state))
    case UPDATE_JOB:
      _.remove(state, { id: action.payload.id });
      state.push(action.payload);
      return JSON.parse(JSON.stringify(state))
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/job.js